import * as React from 'react';
import { render } from 'react-dom';

import { MainComponent } from '../lib';

render(<MainComponent />, document.getElementById('app'));
